import { useSafeLocalStorage } from '@/services/hooks/useSafeLocalStorage'

const checkLocalStorageKeyAndDo = (key: string) => {
  const localStorageItem = useSafeLocalStorage.get(key)

  return !!localStorageItem
}

export default checkLocalStorageKeyAndDo
